<script setup lang="ts">
  import { computed, type HTMLAttributes } from "vue";
  import { cn } from "@/lib/utils";

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes["class"];
      rounded?: boolean;
    }>(),
    {
      class: undefined,
      rounded: true,
    },
  );

  const roundedClass = computed(() => (props.rounded ? "rounded-xl" : ""));
</script>

<template>
  <div
    data-slot="card"
    :class="cn('bg-card text-card-foreground flex flex-col border shadow-sm', roundedClass, props.class)">
    <slot />
  </div>
</template>
